// B5: detecta las redes/destinos que el difusor registró en su perfil, para
// ofrecerlos en el selector de publicación del modal de aprobación. Refleja la
// lógica del backend `validarUrlPost` (columnas planas del perfil +
// `redes_sociales` JSON + `pagina_web`), para que lo que se ofrece coincida con
// lo que el backend acepta como `url_post`.
export default function getRedesDifusor(profile) {
  if (!profile) return {};

  let redes = profile.redes_sociales;
  if (typeof redes === "string") {
    try {
      redes = JSON.parse(redes);
    } catch {
      redes = null;
    }
  }
  redes = redes && typeof redes === "object" ? redes : {};

  // Una red cuenta como registrada si está en la columna plana o en el JSON.
  const pick = (clave) => profile[clave] || redes[clave] || null;

  return {
    facebook: pick("facebook"),
    instagram: pick("instagram"),
    youtube: pick("youtube"),
    spotify: pick("spotify"),
    tiktok: pick("tiktok"),
    // X/Twitter: columna plana `twitter` o, por compatibilidad, redes_sociales.
    twitter: profile.twitter || redes.twitter || redes.x || null,
    pagina_web: profile.pagina_web || null,
  };
}
